import React from "react";
import { Box } from "@mui/material";
import TitleBar from "../../components/navbar/TitleBar";
import Footer from "../../components/common/Footer";
import SchoolBusNavMenu from "../../components/createForm/SchoolBusNavMenu";
import ScheduleMain from "../../components/schedule/ScheduleMain";

export default function SchoolSchedules() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "100vh",
      }}
    >
      <Box>
        <TitleBar />
        <SchoolBusNavMenu />
        <ScheduleMain school />
      </Box>
      <Footer />
    </Box>
  );
}
